import { ROOM_STAGE_LAYOUTS } from "../../const";

export const roomStageLayout = {
  type: "string",
  enum: ROOM_STAGE_LAYOUTS
};
